/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prescription_Session_UnfillableInputs */

const en_us2_prescription_session_unfillable = /** @type {(inputs: Prescription_Session_UnfillableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not build that workout from your equipment and the exercises you have refused. Nothing was changed.`)
};

const pt_br2_prescription_session_unfillable = /** @type {(inputs: Prescription_Session_UnfillableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não conseguimos montar esse treino com o seu equipamento e os exercícios que você recusou. Nada foi alterado.`)
};

const es_419_prescription_session_unfillable = /** @type {(inputs: Prescription_Session_UnfillableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos armar ese entrenamiento con tu equipo y los ejercicios que rechazaste. No se cambió nada.`)
};

const pt_pt2_prescription_session_unfillable = /** @type {(inputs: Prescription_Session_UnfillableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não conseguimos montar esse treino com o teu equipamento e os exercícios que recusaste. Nada foi alterado.`)
};

const fr_fr2_prescription_session_unfillable = /** @type {(inputs: Prescription_Session_UnfillableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de créer cette séance avec ton matériel et les exercices que tu as refusés. Rien n'a été modifié.`)
};

const de_de2_prescription_session_unfillable = /** @type {(inputs: Prescription_Session_UnfillableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit deiner Ausrüstung und den Übungen, die du abgelehnt hast, konnten wir dieses Training nicht erstellen. Es wurde nichts geändert.`)
};

const it_it2_prescription_session_unfillable = /** @type {(inputs: Prescription_Session_UnfillableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non siamo riusciti a creare questo allenamento con la tua attrezzatura e gli esercizi che hai rifiutato. Non è stato modificato nulla.`)
};

/**
* | output |
* | --- |
* | "We could not build that workout from your equipment and the exercises you have refused. Nothing was changed." |
*
* @param {Prescription_Session_UnfillableInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_session_unfillable = /** @type {((inputs?: Prescription_Session_UnfillableInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Session_UnfillableInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_session_unfillable(inputs)
	if (locale === "es-419") return es_419_prescription_session_unfillable(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_session_unfillable(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_session_unfillable(inputs)
	if (locale === "de-DE") return de_de2_prescription_session_unfillable(inputs)
	if (locale === "it-IT") return it_it2_prescription_session_unfillable(inputs)
	return en_us2_prescription_session_unfillable(inputs)
});
export { prescription_session_unfillable as "prescription.session_unfillable" }